import React from "react";
import { Stack, Typography } from "@mui/material";

import { HubIcon } from "../../components";
import { TESTING } from "../../constants/testing";

const WorkOrderTestName = ({ item }) => {
  const testId = item?.testId;
  const TEST = TESTING.find((test) => test.id === testId) || TESTING[0];
  return (
    <Stack
      direction="row"
      gap="10px"
      alignItems="center"
      justifyContent="start"
    >
      <HubIcon icon={TEST?.icon} size="10px" />
      <Typography variant="boldCaptionL" sx={{ fontSize: 11, width: "75px" }}>
        {TEST?.label}
      </Typography>
    </Stack>
  );
};

export default WorkOrderTestName;
